// Blog menu
export const IS_BLOG_MENU_ENABLED = 'blogMenu-isEnabled';
export const IS_BLOG_MENU_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_ENABLED}`;
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED = 'blogMenu-isCategoryLabelsEnabled';
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_CATEGORY_LABELS_ENABLED}`;
export const IS_BLOG_MENU_SEARCH_ENABLED = 'blogMenu-isSearchEnabled';
export const IS_BLOG_MENU_SEARCH_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_SEARCH_ENABLED}`;
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED = 'widget-isLoginButtonEnabled';
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_LOGIN_BUTTON_ENABLED}`;
//# sourceMappingURL=blog-menu.wix-params.js.map